import paths from '../../shared/route/paths'
import AppointmentPage from './Appointment.page'

export const AppointmentModule = {
  isPrivate: true,
  routers: {
    path: paths.APPOINTMENT,
    component: AppointmentPage,
  },
}
